"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAutocompleteOption = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.FdrAutocompleteOption = styled_components_1.default.div.attrs(props => {
    var _a;
    return ({
        className: 'autocomplete-option',
        children: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "-icon" }, props.icon),
            react_1.default.createElement("span", { className: "-label" }, props.label), (_a = props.renderCaption) === null || _a === void 0 ? void 0 :
            _a.call(props))),
    });
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    alignItems: 'center',
    '> .-icon': {
        flexShrink: 0,
        display: 'flex',
        color: 'secondary',
        mr: 2,
    },
}));
//# sourceMappingURL=fdr-autocomplete-option.js.map